



















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import RecuclerMenuList from "@/components/tables/menu/recucler-menu-list.vue";
import ButtonBack from "@/components/buttons/button-back.vue";

import axios from "@/api/AuthAPI/auth-request-api";
import { menu } from "@/config/host.config";

import { AxiosError, AxiosResponse, AxiosRequestConfig } from "axios";
import { IProductCard, ICategory } from "@/@types/menu/menu/menu";

@Component({ components: { RecuclerMenuList, ButtonBack } })
export default class RecyclerMenuList extends Vue {
  @Prop({ type: String, default: "" }) activeBar!: string;
  @Prop({ type: Array, default: () => [] }) categoryList!: Array<ICategory>;

  menuList: Array<IProductCard> = [];

  // reestablish - вотстановить
  async changeDelivery(switchToggle: boolean, id: string): Promise<void> {
    const url = menu.products + "/" + id;
    const data = {
      menu_item: {
        delivery: switchToggle,
      },
    };

    const changeDeliveryResult: AxiosResponse = await axios.put(url, data);

    if (changeDeliveryResult.status === 200) {
      this.createRecuclerMenuList();
    }
  }

  deletedProduct(id: string): void {
    const i = this.menuList.findIndex((el) => el._id == id);
    if (i < 0) this.createRecuclerMenuList();
    else this.menuList.splice(i, 1);
    this.$emit("createList");
  }

  async getRecyclerMenu(): Promise<IProductCard[]> {
    const url = menu.products;
    const config: AxiosRequestConfig = {
      params: {
        "match[shop_id]": this.activeBar,
        "match[deleted][value]": true,
      },
    };
    return new Promise((res, rej) => {
      axios
        .get(url, config)
        .then((menu: AxiosResponse) => {
          if (menu.status === 200) {
            res(menu.data);
          }
        })
        .catch((e: AxiosError) => {
          rej(e);
        });
    });
  }

  @Watch("activeBar")
  createRecuclerMenuList(): void {
    this.getRecyclerMenu().then((menu: IProductCard[]) => {
      this.menuList = menu;
    });
  }

  mounted(): void {
    this.createRecuclerMenuList();
  }
}
